import getProductLineLetter from '../../utils/api/getProductLineLetter';
import { useApiHost, useAppName, useUserOrDefaultProvince } from '../../utils/sitecoreContext';
import { useGetInventoryStatusQuery } from '../apis/hondaRestApi';
const useFetchLegacyInventoryStatus = (transmissions, vehicleType, shouldFetch = true) => {
    const appName = useAppName();
    const hondaRestApi = useApiHost();
    const productLineLetter = vehicleType
        ? getProductLineLetter.get(appName)[vehicleType]
        : getProductLineLetter.get(appName);
    const provinceCode = useUserOrDefaultProvince();
    const validModelCodes = transmissions.map(transmission => transmission === null || transmission === void 0 ? void 0 : transmission.modelCode).filter(Boolean);
    const url = `https://${hondaRestApi}/ecommerce/${productLineLetter}/inventory/stock-multiple/${provinceCode}`;
    return useGetInventoryStatusQuery({ url, body: validModelCodes, transmissions }, {
        skip: !productLineLetter || !hondaRestApi || !validModelCodes.length || !provinceCode || !shouldFetch,
    });
};
export default useFetchLegacyInventoryStatus;
